import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

import "@fontsource/roboto";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/400-italic.css";

import { authActions } from "../../../../store/auth-store/auth-slice";
import {
  SingIn,
  VerifyCaptcha,
} from "../../../../store/auth-store/auth-actions";
import { uiActions } from "../../../../store/ui-slice";

import ABAColor from "../../../../Assets/Img/ABAColor.png";
import "./login.css";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";

const Login = () => {
  const dispatch = useDispatch();

  const isValid = useSelector((state) => state.auth.authValidation);
  const auth = useSelector((state) => state.auth.auth);
  const captchaVerify = useSelector((state) => state.auth.captchaVerify);
  const token = useSelector((state) => state.auth.token);
  const notification = useSelector((state) => state.ui.notification);

  const [token2, setToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const reCaptchaRef = useRef();

  const header = <img alt="Card" className="loginImage" src={ABAColor} />;

  useEffect(() => {
    if (captchaVerify === true) {
      if (auth.email === "" || auth.password === "") {
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: "Existen valores invalidos, favor de revisar.",
          })
        );
        dispatch(authActions.setcaptchaVerify({ captchaVerify: false }));
      } else {
        dispatch(SingIn(auth.email, auth.password));
        dispatch(authActions.setcaptchaVerify({ captchaVerify: false }));
      }
    }
  }, [auth.email, auth.password, captchaVerify, dispatch]);
  

  useEffect(() => {
    if (token !== null && token !== "") {
      window.location.href = "/home";
    }
  }, [dispatch, token]);

  const onChangeHandler = (id, value) => {
    dispatch(authActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  const onSubmitHandler = async (event) => {
    event.preventDefault();
    dispatch(VerifyCaptcha("validate@gmail.com", token2));
  };

  const setTokenFunc = (getToken) => {
    setToken(getToken);
  };

  return (
    <>
      <div className="loginBody">
        <div>
          <div className="field col-12 md:col-12">
            <Card className="loginCard">
              <div>
                <div>{header}</div>
                <div className="field col-12 md:col-3"></div>
                <div className="field col-12 md:col-12 loginTitle">
                  <span className="loginTitleText">Iniciar Sesión(test)</span>
                  <br />
                  <br />
                </div>
                <div className=""></div>
                <form onSubmit={onSubmitHandler}>
                  <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                      <InputText
                        className="loginEmailTextBox"
                        id="email"
                        value={auth.email}
                        onChange={(e) =>
                          onChangeHandler("email", e.target.value)
                        }
                        placeholder="Email"
                      />
                      <div>{getFormErrorMessage("email")}</div>
                    </div>
                    <div className="field col-12 md:col-12">
                      <InputText
                        className="passwordTextBox"
                        id={auth.password}
                        value={auth.password}
                        type="password"
                        onChange={(e) =>
                          onChangeHandler("password", e.target.value)
                        }
                        placeholder="Contraseña"
                      />
                      <div className="forgotPasswordDiv">
                        <Link className="forgotPassword" to={`/forgotpassword`}>
                          <small>¿Olvidaste tu contraseña?</small>
                        </Link>
                      </div>
                      <div>{getFormErrorMessage("password")}</div>
                    </div>
                    {/* <ReCaptcha action="login" 
                      // verifyCallback={handleVerify} 
                      /> */}
                  </div>
                  <Button
                    label="Iniciar sesión"
                    className="loginButton"
                    icon={
                      notification && notification.status === "pending"
                        ? "pi pi-spin pi-spinner"
                        : ""
                    }
                    disabled={notification && notification.status === "pending"}
                  />
                  <GoogleReCaptchaProvider
                    reCaptchaKey={"6Lcu7y0qAAAAAI63Y3aNFiExuMhh2j2wsi9ik5Pp"}
                  >
                    <GoogleReCaptcha
                      className="google-recaptcha-custom-class"
                      onVerify={setTokenFunc}
                      refreshReCaptcha={refreshReCaptcha}
                    />
                  </GoogleReCaptchaProvider>
                </form>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
